
import { config } from '../config';
import { tokenManager } from '../auth/tokenManager';
import { avatarCacheService } from '@/services/avatarCache';

export interface Avatar {
  id: number;
  url: string;
}

export const avatarsApi = {
  getAllAvatars: async (): Promise<Avatar[]> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/avatars`);

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || data.message || response.statusText);
    }

    return response.json();
  },

  updateProfilePicture: async (userId: number, avatarId: number): Promise<void> => {
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/update/${userId}/profile_picture`, {
      method: 'PATCH',
      body: JSON.stringify({ profile_picture: avatarId }),
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || data.message || response.statusText);
    }
    
    // Clear cache for this avatar ID when updating
    avatarCacheService.clearCache(avatarId);
  },

  getAvatarById: async (avatarId: number): Promise<Avatar> => {
    // Try to get from cache first
    const cachedUrl = avatarCacheService.getFromCache(avatarId);
    
    if (cachedUrl) {
      return { id: avatarId, url: cachedUrl };
    }
    
    // If not in cache, fetch from API
    const response = await tokenManager.makeAuthenticatedRequest(`${config.API_URL}/user/avatars/${avatarId}`);

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.detail || data.message || response.statusText);
    }

    const avatar = await response.json();
    
    // Add to cache
    avatarCacheService.addToCache(avatarId, avatar.url);
    
    return avatar;
  }
};
